import React, { FC, useEffect } from "react";
import { Col, DatePicker, Drawer, Form, Row } from "antd";
import { UIButton } from "../../ui/Button";
import { TTemporaryShiftCreateRequest } from "../../../redux-modules/declarations/maps/shifts";
import { UIInput } from "../../ui/Input";
import styled from "styled-components";
import moment from "moment";

interface Props {
  visible: boolean;
  onClose: () => void;
  onSave: (info: TTemporaryShiftCreateRequest) => void;
  isLoading: boolean
}

export const DrawerCreateTurniOccasionali: FC<Props> = ({
  visible,
  onClose,
  onSave,
  isLoading
}: Props): JSX.Element => {
    const [form] = Form.useForm();

    useEffect(() => {
      form.resetFields();
    }, [visible]);

    const handleSave = async () => {
      try {
        const values = await form.validateFields();

        const saveObj: TTemporaryShiftCreateRequest = {
          name: values.name,
          place: values.place,
          date: values.date ? values.date.format("YYYY-MM-DD") : "",
        };

        if (onSave) onSave(saveObj);

      } catch (error) {}
    };

      return <Drawer
        title="Crea Evento"
        placement="right"
        onClose={onClose}
        closable={true}
        visible={visible}
        width={400}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <UIButton onClick={onClose} style={{ marginRight: 8 }}>
              Annulla
            </UIButton>
            <UIButton onClick={handleSave} type="primary" data-cy="new-request-button-save" loading={isLoading}>
              Crea
            </UIButton>
          </div>
        }
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSave}
          data-cy="new-document-form"
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name="name"
                label="Nome"
                rules={[
                  { required: true, message: "Nome obbligatorio" },
                  { whitespace: true, message: "Non può essere vuoto"},
                  { min: 3, message: "Minimo 3 caratteri" },
                  { max: 100, message: "Massimo 100 caratteri" }
                ]}
              >
                <UIInput />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                name="place"
                label="Luogo"
                rules={[
                  { required: true, message: "Luogo obbligatorio" },
                  { whitespace: true, message: "Non può essere vuoto"},
                  { min: 3, message: "Minimo 3 caratteri" },
                  { max: 100, message: "Massimo 100 caratteri" }
                ]}
              >
                <UIInput />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                name="date"
                label="Data"
                rules={[
                  { required: true, message: "Data obbligatoria" },
                ]}
              >
                <CustomDatePicker
                  allowClear={false}
                  format={"DD/MM/YYYY"}
                  value={moment()}
                  disabledDate={(current) => {
                    // disabilita tutte le date fino a oggi inclusa
                    return current && current.isSameOrBefore(moment().endOf("day"));
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>;
}

const CustomDatePicker = styled(DatePicker)`
  width: 100%;
  border-radius: 7px;
  input {
    text-transform: capitalize;
  }
`;